import { css, styled } from 'canoe';

export const ToolbarMenuBodyContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.OnyxGrayD10};
    border-radius: 0.25em;
    display: flex;
    line-height: 21px;
    white-space: nowrap;
    align-items: center;

    & > div > button {
      overflow: hidden;
      align-self: center;
      margin: ${theme.spaces.xxs};
    }

    &[data-popper-reference-hidden='true'] {
      visibility: hidden;
      pointer-events: none;
    }
  `}
`;
